import axios from 'axios'
import { i18n } from '../../plugins/i18n'
import { castAttributesForCamelCase } from '../../modules/string_converter'

export const companiesUsers = {
  namespaced: true,
  state: {
    data: null,
    meta: {},
    loading: false,
    loadError: false,
  },
  getters: {
    meta: (state) => state.meta,
  },
  mutations: {
    readUsers(state) {
      state.data = null
      state.loading = true
      state.loadError = false
    },
    deleteUsers(state) {
      state.loading = true
      state.loadError = false
    },
    readUsersSuccess(state, payload) {
      state.data = payload.data
      state.loading = false
      state.loadError = false
    },
    deleteUsersSuccess(state, userId) {
      state.data = state.data.filter(function(value){
        return value.id != userId
      })
      state.loading = false
      state.loadError = false
    },
    apiFailure(state) {
      state.loading = false
      state.loadError = true
    },
    setMeta(state, meta) {
      state.meta = castAttributesForCamelCase(meta)
    },
  },
  actions: {
    readUsers({ commit }, { company_uuid, except_paginate = false }) {
      commit('readUsers')
      axios
        .get('/api/companies/' + company_uuid + `/users.json?except_paginate=${except_paginate}`)
        .then(res => {
          commit('readUsersSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: errors.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    readUsersForFilter({ commit }, { company_uuid, query }) {
      commit('readUsers')
      axios
        .get('/api/companies/' + company_uuid + '/users.json', { params: query })
        .then(res => {
          commit('setMeta', res.data.meta)
          commit('readUsersSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: errors.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    deleteUsers({ commit }, { company_uuid, user_id }) {
      commit('deleteUsers')
      axios
        .delete('/api/companies/' + company_uuid + '/users/' + user_id + '.json')
        .then(() => {
          commit('deleteUsersSuccess', user_id)
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.deletedDelay', { value: i18n.t('models.user.member') }) }, { root: true })
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: errors.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
  }
}
